<lvr-heading>
	{{ 'sponsor.details.title' | transloco: { name: sponsor().name } }}
</lvr-heading>

@if (sponsor()) {
	<lvr-sponsor-details-view [sponsor]="sponsor()"></lvr-sponsor-details-view>
}
